import moment from 'moment';

export function getTimeLaunch(endDate) {
  const dateCalculate = moment(endDate);
  const now = moment();
  const differences = dateCalculate.diff(now);
  const days = Math.floor(differences / (1000 * 60 * 60 * 24));

  if (days > 0) {
    const timeLauch = {
      days, missingDays: true,
    };
    return timeLauch;
  }

  return { missingDays: false };
}
